<template>
    <div id="parcel_item_main" class="ui centered container segment">
        <div class="ui secondary menu">
            <div class="ui secondary center menu">
                <div class="item">
                    <div class="ui search selection dropdown" id="main_partner_dropdown">
                        <input type="hidden">
                        <i class="dropdown icon"></i>
                        <div class="default text">업체</div>
                        <div class="menu">
                            <div class="item">전체업체</div>
                            <div class="item" v-for="p in getAlivePartners()" :key="p._id">{{ p.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui search selection dropdown" id="main_product_dropdown">
                        <input type="hidden">
                        <i class="dropdown icon"></i>
                        <div class="default text">상품</div>
                        <div class="menu">
                            <div class="item">전체상품</div>
                            <div class="item" v-for="p in products" :key="p._id">{{ p.name }}</div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <select class="ui simple dropdown" v-model="filter.type" @change="updatePage(1)">
                        <option :value="undefined">타입</option>
                        <option :value="constant.TYPE_PARCEL">택배</option>
                        <option :value="constant.TYPE_EXCHANGE">교환</option>
                        <option :value="constant.TYPE_RECALL">회수</option>
                        <option :value="constant.TYPE_AS">A/S</option>
                        <option :value="constant.TYPE_COUPANG">쿠팡</option>
                    </select>
                </div>
                <div class="item">
                    <select class="ui simple dropdown" v-model="filter.company" @change="updatePage(1)">
                        <option :value="undefined">택배사</option>
                        <option :value="'롯데'">롯데</option>
                        <option :value="'대신'">대신</option>
                        <option :value="'로젠'">로젠</option>
                        <option :value="'일양'">일양</option>
                        <option :value="'한진'">한진</option>
                        <option :value="'대한'">대한</option>
                    </select>
                </div>
                <div class="item">
                    <button class="ui teal button" @click="download">다운로드</button>
                </div>
                <div class="item">
                    <button class="ui orange button" @click="updatePage(page)">새로고침</button>
                </div>
            </div>
        </div>
        <div class="ui secondary menu">
            <div class="ui secondary center menu">
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui calendar" id="calendar_start">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="완료날짜(부터)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui calendar" id="calendar_end">
                                <div class="ui input left icon">
                                    <i class="calendar icon"></i>
                                    <input type="text" placeholder="완료날짜(까지)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui input left icon">
                                <i class="user icon"></i>
                                <input type="text" placeholder="주문자" v-model="filter.orderer" @change="updatePage()">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="ui form">
                        <div class="field">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="filter.isCanceled" @change="updatePage(1)">
                                <label>취소건</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrolling content">
            <table class="ui selectable striped celled compact table">
                <thead>
                    <tr>
                        <th class="collapsing">#</th>
                        <th class="collapsing">업체</th>                        
                        <th class="collapsing">판매처</th>
                        <th class="collapsing">타입</th>
                        <th class="collapsing">택배사</th>
                        <th class="collapsing">운송장번호</th>
                        <th class="collapsing">완료날짜</th>
                        <th class="collapsing">주문자</th>
                        <th class="collapsing">상품명</th>
                        <th class="collapsing">수량</th>
                        <th>주소</th>
                        <th class="right collapsing"></th>
                    </tr>
                </thead>
                <tbody v-if="items.length > 0">
                    <tr :class="item.status == constant.STATUS_CANCEL ? 'red' : (item.isCanceled ? 'yellow' : '')" v-for="(item, index) in items" :key="item._id">
                        <td class="collapsing">{{ ((page-1) * 50) + index + 1 }}</td>
                        <td class="collapsing">{{ item.partnerName }}</td>
                        <td class="collapsing">{{ item.seller }}</td>
                        <td class="collapsing">{{ constantNames[item.type] }}</td>
                        <td class="collapsing">{{ item.company }}</td>
                        <td class="collapsing">{{ item.number }}</td>
                        <td class="collapsing">{{ new Date(item.createdAt).format("yyyy-MM-dd(KS)") }}</td>
                        <td class="collapsing">{{ item.orderer }}</td>
                        <td class="collapsing">{{ item.product }}</td>
                        <td class="collapsing">{{ item.count }}</td>
                        <td>{{ item.address }}</td>
                        <td class="right collapsing">
                            <div class="ui small icon buttons">
                                <button :class="item == selected ? 'ui grey button' : 'ui basic button'" @click="openItemDetail(item)">
                                    <i class="file outline icon"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="ui pagination menu">
                <a class="icon item"><i class="left chevron icon"></i></a>
                <a :class="page === i ? 'active item' : 'item'" v-for="i in totalPages" :key="i" @click="onPageClick(i)">{{ i }}</a>
                <a class="icon item"><i class="right chevron icon"></i></a>
            </div>
        </div>
    </div>
</template>

<script>

const moment = require("moment");

export default {
    data: function() {
        return {
            page: 0, totalPages: 0, prevPage: 0, nextPage: 0, filter: 0, items: 0, selected: 0,
        }
    },
    created: function() {
        this.page = 1;
        this.totalPages = 1;
        this.prevPage = null;
        this.nextPage = null;
        this.dateStart = undefined;
        this.dateEnd = undefined;
        this.filter = {};
        this.items = [];
        
    },
    mounted: function() {
        this.updatePage(1);
        this.$ui.calendar_StartEnd("#calendar_start", "#calendar_end",
            (date, text) => { this.filter.dateStart = text; },
            (date, text) => { this.filter.dateEnd = text; this.updatePage(1); });
        this.$ui.dropdown("#main_partner_dropdown", (text) => { this.filter._partner = this.findPartnerId(text); this.updatePage(1); });
        this.$ui.dropdown("#main_product_dropdown", (text) => { this.filter.product = this.findProductName(text.toUpperCase()); this.updatePage(1); });
    },
    methods: {
        findPartnerId(userName) {
            for (const user of this.partners) { if (user.name == userName) return user._id; }
            return undefined;
        },
        findProductName(productName) {
            for (var product of this.products) {
                if (product.name == productName) {
                    return product.name;
                }
            }
            return undefined;
        },
        updatePage(page) {
            if (this.filter.dateStart) { this.filter.dateStart = new Date(this.filter.dateStart); }
            if (this.filter.dateEnd) { this.filter.dateEnd = new Date(this.filter.dateEnd); }
            this.$event.call("openLoading");
            this.$api.getParcelItemList(page, this.filter, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.items = resData.items;
                    this.page = resData.page;
                    this.totalPages = Math.min(resData.totalPages, 10);
                    this.prevPage = resData.prevPage;
                    this.nextPage = resData.nextPage;
                }
            });
        },
        openItemDetail(item) {
            this.selected = item;
            this.$event.call("parcelItemDetail_open", item._id, () => this.updatePage(this.page));
        },
        download() {
            this.$event.call("openLoading");
            this.$api.getAllParcelItems(this.filter, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else if (resData.items && resData.items.length > 0) {
                    console.dir(resData.items);
                    this.$event.call("open_product_counter", resData.items);
                    this.$excel.downloadParcel(this, resData.items, "택배건");
                }
            });
        },
        onPageClick(page) {
            this.updatePage(page);
        },
        onPrevPageClick() {
            if (this.prevPage) { this.updatePage(this.prevPage); }
        },
        onNextPageClick() {
            if (this.nextPage) { this.updatePage(this.nextPage); }
        },
        getAlivePartners()
        {
            const array = [];
            for (const partner of this.partners)
            {
                if (!partner.isTerminated) array.push(partner);
            }
            return array;
        },
    },
    computed: {
        isHeader: function() { return this.$store.getters.isHeader; },
        isPartner: function() { return this.$store.getters.isPartner; },
        isCenter: function() { return this.$store.getters.isCenter; },
        partners: function() { return this.$store.getters.partners; },
        products: function() { return this.$store.getters.products; },
        constant: function() { return this.$store.getters.constant; },
        constantNames: function() { return this.$store.getters.constantNames; },
    },
};
</script>

<style>
#parcel_item_main {
    overflow: auto;
    min-width: 1500px;
    max-width: 1500px;
    min-height: 700px;
}

#parcel_item_main .ui.secondary.menu .item {
    padding: 0;
}

#parcel_item_main .ui.grid {
    padding-bottom: 10px;
}

#parcel_item_main .ui.grid .ui.dropdown {
    margin-top: 3px;
}

#parcel_item_main .ui.table {
    width: 100%;
    padding: 0;
    font-size: 12px;
}

#parcel_item_main .ui.table td {
    max-width: 300px;
}

#parcel_item_main .ui.text.menu {
    margin: 0;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ParcelItemMain.vue